import Immutable from 'immutable';
import { DocId } from 'records/Doc';
import { PageId } from 'records/Page';
import { PublishRequestDiscipline } from 'records/PublishRequestDiscipline';

export type PublishRequestId = string;

export interface RawPublishRequest {
  pageid: PageId;
  documentid: DocId;
  sheetnumber: string;
  sheettitle: string;
  discipline: string;
  sheetDiscipline: PublishRequestDiscipline | null;
  issueddate: number;
  revisioncomment: string;
  // sheetindex: number;
}

export interface PublishRequestData {
  pageid: PageId;
  documentid: DocId;
  sheetnumber: string;
  sheettitle: string;
  discipline: string;
  sheetDiscipline: PublishRequestDiscipline | null;
  issueddate: number;
  revisioncomment: string;
  // sheetindex: number;
}

const defaultValues: PublishRequestData = {
  pageid: '',
  documentid: '',
  sheetnumber: '',
  sheettitle: '',
  discipline: '',
  sheetDiscipline: null,
  issueddate: 0,
  revisioncomment: '',
  // sheetindex: 0,
};

export const PublishRequestFactory = Immutable.Record(
  defaultValues,
  'PublishRequest'
);

export class PublishRequest extends PublishRequestFactory {
  static deserialize(rawPublishRequest: RawPublishRequest): PublishRequest {
    return new PublishRequest({
      ...rawPublishRequest,
    });
  }

  serialize(): RawPublishRequest {
    return this.toJS();
  }
}

export type PublishRequestList = Immutable.List<PublishRequest>;

export type PublishRequestMap = Immutable.OrderedMap<PageId, PublishRequest>;
